import * as THREE from "three";
import { RoundedBoxGeometry } from "three/addons/geometries/RoundedBoxGeometry.js";
import { VISUAL } from "../config/visualConfig";

export function solidBlockGeometry(depth = 0.72): RoundedBoxGeometry {
  const geometry = new RoundedBoxGeometry(VISUAL.cellSize, VISUAL.cellSize, depth, 2, 0.045);
  const position = geometry.getAttribute("position"), uv = geometry.getAttribute("uv");
  // All faces share a vertical UV coordinate, so the light rises continuously
  // from the bottom across the front, sides, bevels and top of the solid.
  for (let i = 0; i < uv.count; i++) uv.setY(i, position.getY(i) / VISUAL.cellSize + 0.5);
  return geometry;
}

export class SolidBlockMaterial extends THREE.MeshPhysicalMaterial {
  readonly sweepTime = { value: 0 };

  constructor() {
    super({ color: 0xffffff, roughness: 0.3, metalness: 0.28, clearcoat: 0.55, clearcoatRoughness: 0.16,
      emissive: 0xffffff, emissiveIntensity: 0.16, transparent: false, opacity: 1, depthWrite: true });
    this.onBeforeCompile = shader => {
      shader.uniforms.blockSweepTime = this.sweepTime;
      shader.vertexShader = `varying float blockUvY;\n${shader.vertexShader}`.replace("#include <begin_vertex>", "#include <begin_vertex>\nblockUvY = uv.y;");
      shader.fragmentShader = `uniform float blockSweepTime;\nvarying float blockUvY;\n${shader.fragmentShader}`
        .replace("#include <color_fragment>", `#include <color_fragment>
          vec3 blockTint = diffuseColor.rgb;
          float phase = fract(blockUvY - blockSweepTime * 0.28);
          float sweep = smoothstep(0.0, 0.1, phase) * (1.0 - smoothstep(0.1, 0.65, phase));
          diffuseColor.rgb *= 0.3 + sweep * 0.45;`)
        .replace("#include <emissivemap_fragment>", `#include <emissivemap_fragment>
          totalEmissiveRadiance *= blockTint;
          totalEmissiveRadiance += blockTint * (0.08 + sweep * 0.75);`);
    };
  }

  override customProgramCacheKey(): string { return "dual-stack-solid-uv-sweep-v1"; }
}
